import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'zeudy-modern-skin',
  styleUrl: 'zeudy-modern-skin.scss',
  shadow: false,
})
export class zeudyModernSkin {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
